module.exports = __webpack_public_path__ + "static/assets/d086bf62bf0fa5ca8de264fb21aedc76.svg";